module.exports = __webpack_public_path__ + "img/step2-6.78a41764.png";